// extracted by mini-css-extract-plugin
export default {"SortableList":"List_SortableList__6EW9A"};